(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rooted-homepage"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('rooted-motion')) {
  customElements.define('rooted-motion', class extends HTMLElement {
    connectedCallback() {
      this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.pointerQuery = window.matchMedia('(hover: hover) and (pointer: fine)');
      this.activeAnimations = new Map();
      this.motionButton = this.querySelector('[data-rs-motion-toggle]');
      this.motionPaused = false;
      try { this.motionPaused = localStorage.getItem('rooted-motion-paused') === 'true'; } catch {}
      this.onMotionToggle = () => {
        this.motionPaused = !this.motionPaused;
        try { localStorage.setItem('rooted-motion-paused', String(this.motionPaused)); } catch {}
        this.configureMotion();
      };
      this.motionButton?.addEventListener('click', this.onMotionToggle);
      this.onPreferenceChange = () => this.configureMotion();
      this.onInteraction = (event) => {
        for (const [element, animation] of this.activeAnimations) {
          if (element.contains(event.target)) animation.finish();
        }
      };
      this.heroArt = this.querySelector('.rs-hero__art');
      this.onArtMove = (event) => {
        if (this.motionQuery.matches || this.motionPaused || !this.pointerQuery.matches || event.pointerType !== 'mouse') return;
        const rect = this.heroArt.getBoundingClientRect();
        const x = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
        const y = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
        this.heroArt.style.setProperty('--rs-art-x', `${x * 5}px`);
        this.heroArt.style.setProperty('--rs-art-y', `${y * 4}px`);
        this.heroArt.style.setProperty('--rs-art-angle', `${x * 0.45}deg`);
      };
      this.resetArt = () => {
        ['--rs-art-x', '--rs-art-y', '--rs-art-angle'].forEach((name) => this.heroArt?.style.removeProperty(name));
      };
      this.motionQuery.addEventListener('change', this.onPreferenceChange);
      this.pointerQuery.addEventListener('change', this.resetArt);
      this.addEventListener('focusin', this.onInteraction);
      this.addEventListener('pointerdown', this.onInteraction, { passive: true });
      this.heroArt?.addEventListener('pointermove', this.onArtMove, { passive: true });
      this.heroArt?.addEventListener('pointerleave', this.resetArt);
      this.configureMotion();
    }

    configureMotion() {
      this.observer?.disconnect();
      for (const animation of this.activeAnimations.values()) animation.cancel();
      this.activeAnimations.clear();
      this.resetArt();
      const disabled = this.motionQuery.matches || window.Shopify?.designMode;
      this.dataset.rsMotion = disabled ? 'reduced' : 'ready';
      this.dataset.rsPaused = String(this.motionPaused);
      if (this.motionButton) {
        this.motionButton.hidden = Boolean(disabled);
        this.motionButton.querySelector('[data-rs-motion-label]').textContent = this.motionPaused ? this.motionButton.dataset.playLabel : this.motionButton.dataset.pauseLabel;
        this.motionButton.querySelector('[data-rs-motion-icon]').textContent = this.motionPaused ? '▷' : 'Ⅱ';
      }
      if (disabled || this.motionPaused || !('IntersectionObserver' in window) || !('animate' in Element.prototype)) return;
      this.observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          this.observer.unobserve(entry.target);
          this.reveal(entry.target);
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -24px 0px' });
      this.querySelectorAll('[data-rs-reveal]:not([data-rs-revealed])').forEach((element) => this.observer.observe(element));
    }

    reveal(element) {
      element.dataset.rsRevealed = 'true';
      // No delayed or hidden CSS state: canceling always restores normal content.
      const illustrated = element.dataset.rsReveal === 'illustration';
      const distance = illustrated ? 22 : 18;
      const from = illustrated ? `translateY(${distance}px) rotate(-1deg) scale(.98)` : `translateY(${distance}px)`;
      const animation = element.animate([
        { opacity: 0.2, transform: from },
        { opacity: 1, transform: 'none' }
      ], {
        duration: illustrated ? 900 : 680,
        delay: Number(element.dataset.rsDelay) || 0,
        easing: 'cubic-bezier(.2,.75,.25,1)',
        fill: 'backwards'
      });
      this.activeAnimations.set(element, animation);
      const cleanup = () => {
        if (this.activeAnimations.get(element) === animation) this.activeAnimations.delete(element);
      };
      animation.addEventListener('finish', cleanup, { once: true });
      animation.addEventListener('cancel', cleanup, { once: true });
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      for (const animation of this.activeAnimations?.values() || []) animation.cancel();
      this.activeAnimations?.clear();
      this.motionButton?.removeEventListener('click', this.onMotionToggle);
      this.motionQuery?.removeEventListener('change', this.onPreferenceChange);
      this.pointerQuery?.removeEventListener('change', this.resetArt);
      this.removeEventListener('focusin', this.onInteraction);
      this.removeEventListener('pointerdown', this.onInteraction);
      this.heroArt?.removeEventListener('pointermove', this.onArtMove);
      this.heroArt?.removeEventListener('pointerleave', this.resetArt);
      this.resetArt?.();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
